<template>
  <div style="width:100%">
    <div v-show="isShow" class="client-detail" >

      <!-- 顶部 返回按钮 和 面包屑 展示所处层级结构 -->
      <div class="detail-header">
        <el-button @click="returnList" size="mini">返回</el-button>
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-left: 20px">
          <el-breadcrumb-item ><b class="linkTo" @click="returnList">客户列表</b></el-breadcrumb-item>
          <el-breadcrumb-item>客户详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content">
        <div class="client-content">
          <!-- 1、客户名称 -->
          <div class="client-name">{{clientName}}</div>
          <!-- 2、客户信息卡片 和 客户评分图表 -->
          <div class="client-main">
            <!-- 客户基本信息卡片 （需要传入一个clientName）-->
            <!-- <ClientDetailCard title="客户信息" :clientName="clientName" btn-name='编辑' @btn-click="editHandle"/> -->
            <ClientDetailCard title="客户信息" :clientName="clientName" btn-name='编辑' @refresh="refresh" @getClientInfo="getClientInfo" />
            <!-- 客户评分图表-->
            <!-- <RateEchart /> -->
          </div>

          <!-- 3、客户联系人 (需要传入一个clientId) -->
          <ClientContact v-if="userDept.p_dept_name=='管理团队'||username=='戚绮琦'|| username=='吴少盈' ||accountManager==username || sales_s_dept_leader==username || username=='张巍瀚' " :clientId="clientId" @contactClick="contactClick" @showMoreContact="showMoreContact" :refreshId="refreshId" />
      
          <div>
            <DataStatistic :clientName="clientName" />
          </div>
          <div>
            <InteractDetail :clientName="clientName" />
          </div>
          <div>
            <ClientPreference :clientName="clientName" :clientId="clientId" />
          </div>
        </div>
      <ControlPanel @addClue="activateClueDialog" />
      <addBusinessDialog v-model="dialogFormVisible" @refresh></addBusinessDialog>
      </div>
    </div>
    
      <!-- 点击更多联系人，展示客户的联系人表格。 -->
      <div v-if="contactShow">
        <Contact :clientId="clientId" :clientName="clientName" @returnClientList="returnList" @returnDetail="isShow = true;contactShow = false;contactDetailShow = false" @refresh="refresh" :refreshId="refreshId" />
      </div>

      <!-- 点击联系人，展示客户的联系人详情。 -->
      <div v-if="contactDetailShow">
        <ContactDetail fromPage="ClientDetail" @returnClientList="returnList" @returnList="isShow = true;contactShow = false;contactDetailShow = false" :clientName="clientName" :clientId="clientId" :contactId="contactId" :contactName="contactName" @refresh="refresh" />
      </div>
  </div>
</template>

<script>
import ClientDetailCard from "@/component/Client/ClientDetail/Card/ClientDetailCard";
import ClientContact from "@/component/Client/ClientDetail/Contact/ClientContact";
import RateEchart from "@/component/Client/ClientDetail/RateEchart/RateEchart";
import ControlPanel from "@/component/Client/ClientDetail/ControlPanel/ControlPanel";
import Contact from "@/component/Client/Contact/Contact";
import ClientPreference from "@/component/Client/ClientDetail/ClientPreference/ClientPreference";
import DataStatistic from '@/component/Client/ClientDetail/DataStatistic/DataStatistic'
import InteractDetail from '@/component/Client/ClientDetail/InteractDetail/InteractDetail'
import ContactDetail from "@/component/Client/Contact/ContactDetail/ContactDetail"
import addBusinessDialog from "@/component/Business/dialog/addBusinessDialog";
export default {
  name: "ClientDetail",
  components: {
    ClientDetailCard,
    ClientContact,
    RateEchart,
    ControlPanel,
    Contact,
    ClientPreference,
    DataStatistic,
    InteractDetail,
    ContactDetail,
    addBusinessDialog
  },
  props:{
    clientName:{
      type:String,
      required:true
    },
    clientId:{
      required:true
    }
  },
  data(){
    return {
      isShow:true,
      refreshId: 0,
      contactDetailShow: false,
      contactShow: false,
      contactName: null,
      contactId: null,
      dialogFormVisible: false,
      username: this.$cookies.get('username'),
      userDept: this.$store.state.userDept,
      accountManager: "",
      sales_s_dept_leader: "",
      sales_s_dept_leader_mapper: {
        "华北销售组": "雷凯文",
        "华东销售组": "张巍瀚",
        "华南销售组": "周晓杰",
        "大客户销售组": "张巍瀚",
        "银行销售组": "崔天恒",
        "新道销售组": "陈晓乾"
      }
    }
  },
  methods:{
    // 点击更多联系人按钮，隐藏客户详细信息，显示联系人表格
    showMoreContact(){
      this.isShow = false
      this.contactShow = true
      this.contactDetailShow = false
    },
    // 点击返回按钮返回客户列表页面
    returnList(){
      this.$emit('returnList')
    },
    refresh(value='') {
      if (value == 'clientEdit'){
        this.$emit('refresh')
      }else{
        this.refreshId += 1
      }
    },
    contactClick(contactItem) {
      this.isShow = false
      this.contactShow = false
      this.contactDetailShow = true
      
      this.contactName = contactItem.name
      this.contactId = contactItem.contact_id
    },
    activateClueDialog(){
      this.dialogFormVisible = true
    },

    getAccountManager(accountManager) {
      this.accountManager = accountManager
    },

    getClientInfo(clientInfo){
      this.accountManager = clientInfo.account_manager_name
      this.sales_s_dept = clientInfo.secondary_dept
      this.sales_s_dept_leader = this.sales_s_dept_leader_mapper[this.sales_s_dept]
    }

  }
}
</script>

<style scoped>
.detail-header{
  display: flex;
  align-items: center;
}

.content {
  display: flex;
  justify-content: space-between;
}

.client-content {
  width: 85%;
}
.linkTo{
  cursor: pointer;
}
.linkTo:hover{
  color:#1473E3;
}
.client-name{
  width: 100%;
  box-shadow:0 0px 12px 0 rgb(0 0 0 / 10%);
  border-radius: 5px;
  padding: 30px;
  margin-top: 10px;
  font-weight: bold;
  font-size:18px;
  /* min-width: 1754px; */
}
</style>